import { createUserlist,createExternalUserlist } from "../../models/userlist.model";
import { createUserDetails } from "../../models/user-details.model";

export const userGetters = {
  userlist: (state) => createUserlist(state.userlist),
  // userDetails: (state) => createUserDetails(state.userDetails),
  userDetails: (state) => state.userDetails

};